import { render, staticRenderFns } from "./EditEmpresa.vue?vue&type=template&id=6a8abdb9"
import script from "./EditEmpresa.vue?vue&type=script&lang=js"
export * from "./EditEmpresa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports